import { Component, Input } from '@angular/core';

import { CustomerInfo } from './types';

@Component({
  selector: 'tablesready-party-customer-info',
  templateUrl: './party-customer-info.component.html',
  standalone: false,
})
export class PartyCustomerInfoComponent {
  @Input() customer: CustomerInfo;
  @Input() timezone: string;
}
